import { render } from "./BaseCircles.vue?vue&type=template&id=55a0b38d&scoped=true&ts=true"
import script from "./BaseCircles.vue?vue&type=script&lang=ts"
export * from "./BaseCircles.vue?vue&type=script&lang=ts"

import "./BaseCircles.vue?vue&type=style&index=0&id=55a0b38d&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a0b38d"]])

export default __exports__